var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m89.917 67.042-4.542-31.917c-1.167-8.208-8.208-14.292-16.5-14.292h-37.75c-8.292 0-15.333 6.084-16.5 14.292l-4.542 31.917c-.916 6.416 4.042 12.125 10.5 12.125 2.834 0 5.5-1.125 7.5-3.125l9.417-9.375h25l9.375 9.375c2 2 4.708 3.125 7.5 3.125 6.5 0 11.458-5.709 10.542-12.125zM45.833 45.833H37.5v8.334h-4.167v-8.334H25v-4.166h8.333v-8.334H37.5v8.334h8.333v4.166zM62.5 41.667a4.179 4.179 0 0 1-4.167-4.167 4.179 4.179 0 0 1 4.167-4.167 4.179 4.179 0 0 1 4.167 4.167 4.179 4.179 0 0 1-4.167 4.167zm8.333 12.5A4.179 4.179 0 0 1 66.667 50a4.179 4.179 0 0 1 4.166-4.167A4.179 4.179 0 0 1 75 50a4.179 4.179 0 0 1-4.167 4.167z",
    fill: "#61A351",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.9a7220757bbdaea2116e592657a984f5.svg";
export { ForwardRef as ReactComponent };